
import { combineLatest, Subscription } from 'rxjs';
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { PublicationService } from '../services/publication.service';

@Directive({
	selector: '[hasPublicationFieldOrPermission]'
})

export class HasPublicationFieldOrPermissionDirective implements OnInit, OnDestroy {

	@Input() hasPublicationFieldOrPermission: string;
	private subscriptions = new Subscription();

	constructor(
		private el: ElementRef,
		private publicationService: PublicationService,
		private authenticationService: AuthenticationService
	) {
		this.showElement(false);
	}

	ngOnInit() {
		let extraPublicationFields: string[];

		const hasPermissionObservable = this.authenticationService.hasPermission('root');
		const publicationDataObservable = this.publicationService.getData();
		const hasPermissionObservable2 = this.authenticationService.hasPermission(this.hasPublicationFieldOrPermission);

		this.subscriptions.add(combineLatest([
			hasPermissionObservable,
			publicationDataObservable,
			hasPermissionObservable2
		]).subscribe((res: any[]) => {

			const hasRoot = res[0];
			const publicationData = res[1];
			const hasPermission = res[2];

			let publicationFieldEnabled = false;
			if (publicationData) {
				extraPublicationFields = (publicationData.extraPlayoutFields ?
					(
						typeof publicationData.extraPlayoutFields === 'string' ?
							JSON.parse(publicationData.extraPlayoutFields) : publicationData.extraPlayoutFields
					) : []);
				publicationFieldEnabled = extraPublicationFields.indexOf(this.hasPublicationFieldOrPermission) !== -1;
			}

			if (hasRoot || (publicationFieldEnabled || hasPermission)) {
				this.showElement(true, (publicationFieldEnabled || hasPermission));
			} else {
				this.showElement(false);
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	private showElement(show: boolean, fieldEnabled?: boolean) {
		this.el.nativeElement.style.display = show ? null : 'none';
		if (fieldEnabled) {
			this.el.nativeElement.classList.remove('root');
		} else {
			this.el.nativeElement.classList.add('root');
		}
	}
}
